import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  OnInit,
  OnChanges,
} from "@angular/core";
import { IndicateStatus } from "../../../domain/enums";

@Component({
  selector: "circle-indicator",
  templateUrl: "./circleIndicator.component.html",
  styleUrls: ["./circleIndicator.component.scss"],
})

// tslint:disable-next-line:component-class-suffix
export class CircleIndicator implements OnInit, OnChanges {
  @ViewChild("secondLayer", { static: true }) secondLayer: ElementRef;

  @Input()
  status: IndicateStatus = IndicateStatus.None;

  success: IndicateStatus = IndicateStatus.Success;
  failed: IndicateStatus = IndicateStatus.Failed;

  /**
   * Booting up the component
   * @return void
   */
  ngOnInit() {
    const half = this.secondLayer.nativeElement.getTotalLength() / 2;

    /* Make Second Layer 50% */
    this.secondLayer.nativeElement.style.strokeDashoffset = half;
    this.secondLayer.nativeElement.style.strokeDasharray = half;
  }

  /**
   * On Change (Ng-Change)
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    /* Validating status */
    if (changes["status"]) {
    }
  }
}
